import type { ConsentSettings } from '../types';

export const getDefaultConsent = (): ConsentSettings => ({
  ad_storage: 'denied',
  analytics_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  functionality_storage: 'denied',
  personalization_storage: 'denied',
  security_storage: 'granted'
});

export const updateConsent = (settings: ConsentSettings) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'consent_update',
    consent: settings
  });
};